export const GET_REFUNDS = 'refunds/GET_REFUNDS';
export const GET_REFUNDS_SUCCESS = 'refunds/GET_REFUNDS_SUCCESS';
export const GET_REFUNDS_FAIL = 'refunds/GET_REFUNDS_FAIL';

export const NEW_REFUND = 'refunds/NEW_REFUND';
export const NEW_REFUND_SUCCESS = 'refunds/NEW_REFUND_SUCCESS';
export const NEW_REFUND_FAIL = 'refunds/NEW_REFUND_FAIL';

export const GET_ZENDESK_DATA = 'refunds/GET_ZENDESK_DATA';
export const GET_ZENDESK_DATA_SUCCESS = 'refunds/GET_ZENDESK_DATA_SUCCESS';
export const GET_ZENDESK_DATA_FAIL = 'refunds/GET_ZENDESK_DATA_FAIL';

export const NEW_COMMENT = 'refunds/NEW_COMMENT';
export const NEW_COMMENT_SUCCESS = 'refunds/NEW_COMMENT_SUCCESS';
export const NEW_COMMENT_FAIL = 'refunds/NEW_COMMENT_FAIL';

export const UPDATE_REFUND_STATUS = 'refunds/UPDATE_REFUND_STATUS';
export const UPDATE_REFUND_STATUS_SUCCESS = 'refunds/UPDATE_REFUND_STATUS_SUCCESS';
export const UPDATE_REFUND_STATUS_FAIL = 'refunds/UPDATE_REFUND_STATUS_FAIL';

export const UPDATE_REFUND = 'refunds/UPDATE_REFUND';
export const UPDATE_REFUND_SUCCESS = 'refunds/UPDATE_REFUND_SUCCESS';
export const UPDATE_REFUND_FAIL = 'refunds/UPDATE_REFUND_FAIL';

export const GET_REFUNDS_SUMMARY = 'refunds/GET_REFUNDS_SUMMARY';
export const GET_REFUNDS_SUMMARY_SUCCESS = 'refunds/GET_REFUNDS_SUMMARY_SUCCESS';
export const GET_REFUNDS_SUMMARY_FAIL = 'refunds/GET_REFUNDS_SUMMARY_FAIL';

export const RESET_ZENDESK_FIELDS = 'refunds/RESET_ZENDESK_FIELDS';

export const UPLOAD_FILES = 'refunds/UPLOAD_FILES';
export const UPLOAD_FILES_SUCCESS = 'refunds/UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAIL = 'refunds/UPLOAD_FILES_FAIL';

export const GET_COMPLETED_REFUNDS = 'refunds/GET_COMPLETED_REFUNDS';
export const GET_COMPLETED_REFUNDS_SUCCESS = 'refunds/GET_COMPLETED_REFUNDS_SUCCESS';
export const GET_COMPLETED_REFUNDS_FAIL = 'refunds/GET_COMPLETED_REFUNDS_FAIL';

export const ADD_REFUND = 'refunds/ADD_REFUND';
export const REPLACE_REFUND = 'refunds/REPLACE_REFUND';

export const GET_REFUNDS_COUNT = 'refunds/GET_REFUNDS_COUNT';
export const GET_REFUNDS_COUNT_SUCCESS = 'refunds/GET_REFUNDS_COUNT_SUCCESS';
export const GET_REFUNDS_COUNT_FAIL = 'refunds/GET_REFUNDS_COUNT_FAIL';

export const GET_REFUND = 'refunds/GET_REFUND';
export const GET_REFUND_SUCCESS = 'refunds/GET_REFUND_SUCCESS';
export const GET_REFUND_FAIL = 'refunds/GET_REFUND_FAIL';

export const GET_REFUND_TRANSACTIONS = 'refunds/GET_REFUND_TRANSACTIONS';
export const GET_REFUND_TRANSACTIONS_SUCCESS = 'refunds/GET_REFUND_TRANSACTIONS_SUCCESS';
export const GET_REFUND_TRANSACTIONS_FAIL = 'refunds/GET_REFUND_TRANSACTIONS_FAIL';

export const MAKE_REFUND = 'refunds/MAKE_REFUND';
export const MAKE_REFUND_SUCCESS = 'refunds/MAKE_REFUND_SUCCESS';
export const MAKE_REFUND_FAIL = 'refunds/MAKE_REFUND_FAIL';

export const MAKE_REFUNDS = 'refunds/MAKE_REFUNDS';
export const MAKE_REFUNDS_SUCCESS = 'refunds/MAKE_REFUNDS_SUCCESS';
export const MAKE_REFUNDS_FAIL = 'refunds/MAKE_REFUNDS_FAIL';

export const SWITCH_REFUND_METHOD = 'refunds/SWITCH_REFUND_METHOD';
export const SWITCH_REFUND_METHOD_SUCCESS = 'refunds/SWITCH_REFUND_METHOD_SUCCESS';
export const SWITCH_REFUND_METHOD_FAIL = 'refunds/SWITCH_REFUND_METHOD_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/refunds.js